import React, { useContext } from "react";
import "./AddUser.css";

import boxbg from "../../assets/user_photo.svg";
import FormContext from "../../context/FormContext";
import { ReactSession } from "react-client-session";

const AddBox = () => {
  const { isFormOpen, setIsFormOpen } = useContext(FormContext);

  const username = ReactSession.get("username");

  const registerUserHandler = () => {
    setIsFormOpen(!isFormOpen);
  };

  return (
    <div className="supervisor-addbox-flex-container">
      <section className="supervisor-addbox-sec-1">
        <div>
          <p className="supervisor-addbox-sec-1-head">Welcome back,</p>
          <a className="supervisor-addbox-sec-1-user_name" href="/">
            {username}
          </a>
        </div>

        <div className="supervisor-addbox-sec-1-btn-container">
          <button
            onClick={registerUserHandler}
            className="supervisor-addbox-sec-1-btn"
          >
            Add new 
            <br />
            Operator +
          </button>
        </div>
      </section>

      <section className="supervisor-addbox-sec-2">
        <img className="supervisor-addbox-box-bg" src={boxbg} alt="asd" />
      </section>
    </div>
  );
};

export default AddBox;
